import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const LinkIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.30558 10.9365C9.57224 11.2031 9.59447 11.6217 9.37225 11.9136L9.30558 11.9899L6.84751 14.448C5.58692 15.7086 3.54311 15.7086 2.28252 14.448C1.0654 13.2309 1.02344 11.2836 2.15661 10.0162L2.28252 9.88304L4.74059 7.42496C5.0315 7.13406 5.50315 7.13406 5.79405 7.42496C6.06071 7.69163 6.08294 8.11016 5.86072 8.40214L5.79405 8.47842L3.33598 10.9365C2.6572 11.6152 2.6572 12.7158 3.33598 13.3945C3.98082 14.0394 5.00628 14.0716 5.68918 13.4913L5.79405 13.3945L8.25212 10.9365C8.54303 10.6456 9.01468 10.6456 9.30558 10.9365ZM9.82982 6.90072C10.1207 7.19162 10.1207 7.66327 9.82982 7.95418L7.34921 10.4348C7.0583 10.7257 6.58665 10.7257 6.29575 10.4348C6.00484 10.1439 6.00484 9.67225 6.29575 9.38134L8.77637 6.90072C9.06727 6.60981 9.53892 6.60981 9.82982 6.90072ZM13.7175 3.01303C14.9346 4.23015 14.9766 6.17741 13.8434 7.44489L13.7175 7.57802L11.2594 10.0361C10.9685 10.327 10.4969 10.327 10.206 10.0361C9.93931 9.76944 9.91709 9.3509 10.1393 9.05892L10.206 8.98264L12.664 6.52456C13.3428 5.84578 13.3428 4.74527 12.664 4.06649C12.0192 3.42165 10.9938 3.38941 10.3109 3.96976L10.206 4.06649L7.74791 6.52456C7.457 6.81547 6.98535 6.81547 6.69445 6.52456C6.42779 6.2579 6.40556 5.83936 6.62778 5.54739L6.69445 5.4711L9.15252 3.01303C10.4131 1.75244 12.4569 1.75244 13.7175 3.01303Z"
		/>
	</svg>
))
